const isDate = (val) => {
  return (
    Object.prototype.toString.call(val) === '[object Date]' ||
    val instanceof Date
  );
};

export interface OptionsType {
  domain?: string;
  expires?: Date;
  path?: string;
  maxAge?: number;
}

export const serialize = (
  name: string,
  val: string,
  options?: OptionsType
): string => {
  let str = name + '=' + encodeURIComponent(val);

  if (null != options.maxAge) {
    const maxAge = options.maxAge - 0;

    if (isNaN(maxAge) || !isFinite(maxAge)) {
      throw new TypeError('option maxAge is invalid');
    }

    str += '; Max-Age=' + Math.floor(maxAge);
  }

  if (options.domain) {
    str += '; Domain=' + options.domain;
  }

  if (options.path) {
    str += '; Path=' + options.path;
  }

  if (options.expires) {
    const expires = options.expires;

    if (!isDate(expires) || isNaN(expires.valueOf())) {
      throw new TypeError('option expires is invalid');
    }

    str += '; Expires=' + expires.toUTCString();
  }

  return str;
};

export type CookieValueTypes = string | undefined;
export type TmpCookiesObj =
  | { [key: string]: string }
  | Partial<{ [key: string]: string }>;

const stringify = (value) => {
  try {
    if (typeof value === 'string') {
      return value;
    }
    return JSON.stringify(value);
  } catch (e) {
    return value;
  }
};

const decode = (str: string): string => {
  if (!str) return str;

  return str.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
};

export const getCookies = (): TmpCookiesObj => {
  const _cookies: TmpCookiesObj = {};
  const documentCookies =
    typeof document !== 'undefined' ? document.cookie.split('; ') : [];

  for (let i = 0, len = documentCookies.length; i < len; i++) {
    const cookieParts = documentCookies[i].split('=');

    const _cookie = cookieParts.slice(1).join('=');
    const name = cookieParts[0];

    _cookies[name] = _cookie;
  }

  return _cookies;
};

export const getCookie = (key: string): CookieValueTypes => {
  const _cookies = getCookies();
  const value = _cookies[key];
  if (value === undefined) return undefined;
  return decode(value);
};

export const setCookie = (key: string, data, options?: OptionsType): void => {
  const cookieStr = serialize(key, stringify(data), {
    path: '/',
    ...options
  });

  document.cookie = cookieStr;
};

export const deleteCookie = (key: string, options?: OptionsType): void => {
  return setCookie(key, '', { ...options, maxAge: -1 });
};

export const getPartNumberCookie = (name: string) => {
  let value = null;
  const cookiesString = `; ${document.cookie}`;
  const cookies = cookiesString.split(`; ${name}=`);
  if (cookies.length >= 2) {
    value = cookies.pop().split(';').shift();
  }
  return value;
};

export const setPartNumberCookie = (
  name: string,
  value: string,
  path: string,
  expires: string = null,
  domain = null
) => {
  const expiresString = expires ? `;expires=${expires}` : '';
  const domainString = domain ? `;domain=${domain}` : '';
  document.cookie = `${name}=${value}${expiresString};path=${path}${domainString}`;
};